import {
  createApiFactory,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';

import { PrReviewDashboardApiClient, prReviewDashboardApiRef } from './api';
import { rootRouteRef } from './routes';

/** Registers the dashboard route and its default Code Reviewer API client. */
export const prReviewDashboardPlugin = createPlugin({
  id: 'pr-review-dashboard',
  routes: {
    root: rootRouteRef,
  },
  apis: [
    createApiFactory({
      api: prReviewDashboardApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new PrReviewDashboardApiClient(discoveryApi, fetchApi),
    }),
  ],
});

/** Page extension that mounts the review explorer and details views. */
export const PrReviewDashboardPage = prReviewDashboardPlugin.provide(
  createRoutableExtension({
    name: 'PrReviewDashboardPage',
    component: () => import('./components/App').then(module => module.App),
    mountPoint: rootRouteRef,
  }),
);
